<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePipelinesStore } from 'dashboard/stores/pipelines';
import { buildTimelineEventMessages } from 'dashboard/helper/timelineMessageHelper';

const props = defineProps({
  event: { type: Object, required: true },
  resolveCompanyName: { type: Function, default: null },
  resolveContactName: { type: Function, default: null },
});

const { t, te, locale } = useI18n();
const pipelinesStore = usePipelinesStore();

const resolveStageName = id => {
  const pipeline = pipelinesStore.getPipelinesList.find(p =>
    (p.stages || []).some(stage => stage.id === id)
  );
  const stage = pipeline?.stages?.find(s => s.id === id);
  return stage?.name ?? id;
};

const messages = computed(() =>
  buildTimelineEventMessages(props.event, {
    locale: locale.value,
    t,
    te,
    resolveStageName,
    resolveCompanyName: props.resolveCompanyName ?? undefined,
    resolveContactName: props.resolveContactName ?? undefined,
  })
);
</script>

<template>
  <div v-for="message in messages" :key="message" class="flex justify-center">
    <div
      class="px-3 py-1 rounded-xl bg-n-alpha-1 text-n-slate-11 text-sm text-center max-w-[90%]"
    >
      {{ message }}
    </div>
  </div>
</template>
